<template>
  <Button
    severity="danger"
    icon="pi pi-trash"
    size="small"
    variant="text"
    @click="destroy()"
  />

  <Toast />
</template>

<script lang="ts" setup>
const props = defineProps({
  noteId: String,
})
const emit = defineEmits(['refresh'])
const toast = useToast()
const { deleteNote } = useNotes()
const isLoading = ref(false)

const destroy = async () => {
  isLoading.value = true
  if (confirm('Are you sure?')) {
    const { data, error } = await deleteNote(props.noteId)

    if (error) {
      toast.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to delete note',
        life: 3000,
      })
      return
    }
    else {
      toast.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Successfully deleted note',
        life: 3000,
      })
    }

    emit('refresh')
  }
}
isLoading.value = false
</script>
